// Function 'json' was generated by Gemini 2.0 Flash
const json = (jsonString: string) => {
  // Regex to capture different JSON tokens
  const JSON_REGEX = new RegExp(
    [
      /("(?:\\.|[^"\\])*")/, // Group 1: String (keys and values)
      /(-?\b\d+\.?\d*\b)/, // Group 2: Number
      /(\b(true|false|null)\b)/, // Group 3 (full), 4 (Boolean/Null value)
      /([{}[\],:])/, // Group 5: Punctuation
    ]
      .map(r => r.source)
      .join('|'),
    'g'
  )

  return jsonString.replace(JSON_REGEX, (...params) => {
    const [match, ...groupsRest] = params
    const groups = groupsRest.slice(0, -2)
    const originalString = groupsRest.at(-1) as string
    const offset = groupsRest.at(-2) as number

    let styleClass = ''

    // Find the index of the first defined capture group
    let groupIndex1Based = -1
    for (let i = 0; i < groups.length; i++) {
      if (groups[i] !== undefined) {
        groupIndex1Based = i + 1
        break
      }
    }

    switch (groupIndex1Based) {
      case 1: {
        // String
        // Check if it's a key (followed by a colon) or a value
        const nextChar = originalString[offset + match.length]
        styleClass = nextChar === ':' ? 'text-[#7dd3fc]' : 'text-[#14b8a6]'
        break
      }
      case 2: // Number
        styleClass = 'text-[#818cf8]'
        break
      case 3: // Boolean/Null
        styleClass = 'text-[#f59e0b]'
        break
      case 5: // Punctuation
        styleClass = 'text-[#9ca3af]'
        break
      default:
        return match
    }

    return styleClass ? `<span class="${styleClass}">${match}</span>` : match
  })
}

// Function 'graphql' was generated by Gemini 2.5 Pro
const graphql = (query: string) => {
  // Regex to capture different GraphQL tokens
  // Order matters: more specific patterns first (strings, comments)
  const GQL_REGEX = new RegExp(
    [
      /(#[^\n\r]*)/, // Group 1: Comment
      /("(?:\\.|[^"\\])*")/, // Group 2: String
      /(\b(query|mutation|subscription|fragment|on)\b)/, // Group 3 (full), 4 (keyword)
      /(\$[a-zA-Z_]\w*)/, // Group 5: Variable
      /(\.\.\.\s*[a-zA-Z_]\w*)/, // Group 6: Fragment Spread
      /(\b([A-Z][a-zA-Z0-9_]*)\b)/, // Group 7 (full), 8 (Type name)
      /(\b(true|false|null)\b)/, // Group 9 (full), 10 (value)
      /(-?\b\d+\.?\d*\b)/, // Group 11: Number
      /(__typename)/, // Group 12: __typename
      /([a-zA-Z_]\w*)/, // Group 13: Field/Argument/Name
      /([{}():,![\]])/, // Group 14: Punctuation
    ]
      .map(r => r.source)
      .join('|'),
    'g'
  )

  // The replacer function correctly receives:
  // match: The entire matched string
  // ...captures: All capture group results (e.g., g1, g2, g3, g4, ...)
  // offset: The index where the match was found
  // originalString: The original full string
  return query.replace(GQL_REGEX, (...params) => {
    const [match, ...groupsRest] = params
    const groups = groupsRest.slice(0, -2)
    const originalString = groupsRest.at(-1) as string
    const offset = groupsRest.at(-2) as number

    let styleClass = ''

    // Find the index of the first defined capture group
    // Note: Regex group indices are 1-based, array indices are 0-based.
    let groupIndex1Based = -1
    for (let i = 0; i < groups.length; i++) {
      if (groups[i] !== undefined) {
        groupIndex1Based = i + 1
        break
      }
    }

    // Assign HEX-based classes based on which group matched (using 1-based index)
    switch (groupIndex1Based) {
      case 1: // Comment (group 1)
        styleClass = 'text-[#a0aec0] italic'
        break
      case 2: // String (group 2)
        styleClass = 'text-[#34d399]'
        break
      case 3: // Keyword (group 3 - contains full match like \bquery\b)
        styleClass = 'text-[#a78bfa] font-semibold'
        break
      // group 4 is the specific keyword, but group 3 is enough to trigger the style
      case 5: // Variable (group 5)
        styleClass = 'text-[#f59e0b]'
        break
      case 6: // Fragment Spread (group 6)
        styleClass = 'text-[#ec4899]'
        break
      case 7: // Type/Enum Name (group 7 - contains full match like \bUUID\b)
        styleClass = 'text-[#14b8a6]'
        break
      // group 8 is the specific type name
      case 9: // Boolean/Null (group 9)
        styleClass = 'text-[#22d3ee]'
        break
      // group 10 is the specific value
      case 11: // Number (group 11)
        styleClass = 'text-[#818cf8]'
        break
      case 12: // __typename (group 12)
        styleClass = 'text-[#0ea5e9] italic'
        break
      case 13: {
        // Field/Argument/Fragment Name (group 13)
        // Use the correct 'string' and 'offset' arguments from the replacer
        const prevText = originalString.substring(Math.max(0, offset - 15), offset)
        if (/\bfragment\s+$/.test(prevText)) {
          styleClass = 'text-[#ec4899] font-semibold' // Fragment Definition Name
        } else if (/\b(?:query|mutation)\s+$/.test(prevText)) {
          styleClass = 'text-[#fbbf24] font-semibold' // Operation Definition Name
        } else {
          styleClass = 'text-[#7dd3fc]' // Default Field/Argument
        }
        break
      }

      case 14:
        styleClass = 'text-[#9ca3af]' // Punctuation (group 14)
        break
      default: // Should not happen if regex covers all non-whitespace
        return match
    }

    return styleClass ? `<span class="${styleClass}">${match}</span>` : match
  })
}

export const syntaxHighlighter = {
  json,
  graphql,
}
